import './table.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as Add } from '../../assets/icons/add.svg';
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-right.svg';
import { HEADERS, PERMISSIONS } from '../../config';
import { useHasPermission } from '../../hooks';
import { Button } from '..';
import { DataTable } from './table';
import { TableFilters } from './table-filters';

const TableWrapper = ({
  data,
  exportData,
  name,
  headerName,
  title,
  link,
  onLoadMore,
  canLoadMore,
  hasFilters,
  isLoading,
  isFetching,
  onSearch,
  searchPlaceholder,
  onClear,
  onStatusChange,
  onDateFilter,
  emptyDataComponent,
  rowClick,
  rowAction,
  exportUrl,
  ...props
}) => {
  const hasPermission = useHasPermission();
  const canManagePaymentLink = hasPermission(PERMISSIONS.PAYMENT_LINKS_MANAGE);

  return (
    <div className="card table-wrapper ">
      <div className="card__header">
        {title && (
          <h3 className="card__title">
            {title} <span className="text-cursive">{name}</span>
          </h3>
        )}
        {link && <TableWrapperLink link={link} name={name} location="top" />}
        {props.addOn && <div className="card__header__addon">{props.addOn}</div>}
      </div>
      {hasFilters && !!data && (
        <TableFilters
          onSearch={onSearch}
          searchPlaceholder={searchPlaceholder}
          onClear={onClear}
          dataToExport={exportData && name.toUpperCase()}
          filter={name}
          exportUrl={exportUrl}
          onStatusChange={onStatusChange}
          onDateFilter={onDateFilter}
          addon={
            name === 'links' && canManagePaymentLink ? (
              <Button onClick={props.openModal} className="card__title__link">
                Add Payment Link
                <Add />
              </Button>
            ) : (
              <></>
            )
          }
        />
      )}

      <DataTable
        isFetching={isFetching}
        headers={HEADERS[headerName || name]}
        data={data}
        emptyDataComponent={emptyDataComponent}
        rowClick={rowClick}
        rowAction={rowAction}
      />

      <div className="card__footer">
        {link && <TableWrapperLink link={link} name={name} location="bottom" />}
        {canLoadMore && (
          <Button className="card__footer__button" onClick={onLoadMore}>
            Load{isLoading && 'ing'} more {name} {isLoading ? '...' : <ArrowRight />}
          </Button>
        )}
      </div>
    </div>
  );
};

const TableWrapperLink = ({ link, name, location = 'bottom' }) => {
  const { url, text, position = 'bottom' } = link ?? {};

  if (location === position) {
    return (
      <Link to={url || link} className="card__title__link">
        {text ? text : `See all ${name} history`} <ArrowRight />
      </Link>
    );
  } else {
    return null;
  }
};

TableWrapperLink.propTypes = {
  link: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string,
  location: PropTypes.string
};
TableWrapper.defaultProps = {
  linkPosition: 'bottom'
};
TableWrapper.propTypes = {
  data: PropTypes.array,
  name: PropTypes.string,
  headerName: PropTypes.string,
  title: PropTypes.string,
  link: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onLoadMore: PropTypes.func,
  onSearch: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  onClear: PropTypes.func,
  onStatusChange: PropTypes.func,
  onDateFilter: PropTypes.func,
  canLoadMore: PropTypes.bool,
  hasFilters: PropTypes.bool,
  isLoading: PropTypes.bool,
  isFetching: PropTypes.bool,
  openModal: PropTypes.func,
  emptyDataComponent: PropTypes.element,
  exportData: PropTypes.bool,
  addOn: PropTypes.element,
  rowClick: PropTypes.func,
  rowAction: PropTypes.func,
  exportUrl: PropTypes.string
};

export { TableWrapper };
